import React from 'react'

// components
import RegistrationStep from 'components/register/shared/RegistrationStep'
import Loading from 'components/atoms/Loading'
import Typography from '@mui/material/Typography'

// containers
import Form from 'components/account/PickupPeople/Form'

const NewPickupPerson = props => {
  const { mutationLoading, form } = props

  return (
    <RegistrationStep>
      <Typography pb={4} variant='h2' align='center'>
        Add a Pickup Person
      </Typography>

      {!form ? (
        <Loading />
      ) : (
        <Form
          buttonText={mutationLoading ? 'Creating...' : 'Create'}
          {...props}
        />
      )}
    </RegistrationStep>
  )
}

export default NewPickupPerson
